export const Referal = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3743 4.62435V2.95768C13.3743 2.03721 12.6282 1.29102 11.7077 1.29102H2.95768C2.03721 1.29102 1.29102 2.03721 1.29102 2.95768V11.7077C1.29102 12.6282 2.03721 13.3743 2.95768 13.3743H4.62435M6.77124 16.7077C7.15529 14.8028 8.75317 13.3743 10.666 13.3743C12.5789 13.3743 14.1767 14.8028 14.5608 16.7077M6.77124 16.7077H6.29102C5.37054 16.7077 4.62435 15.9615 4.62435 15.041V6.29102C4.62435 5.37054 5.37054 4.62435 6.29102 4.62435H15.041C15.9615 4.62435 16.7077 5.37054 16.7077 6.29102V15.041C16.7077 15.9615 15.9615 16.7077 15.041 16.7077H14.5608M6.77124 16.7077H14.5608M12.541 9.41602C12.541 10.4516 11.7016 11.291 10.666 11.291C9.63048 11.291 8.79102 10.4516 8.79102 9.41602C8.79102 8.38048 9.63048 7.54102 10.666 7.54102C11.7016 7.54102 12.541 8.38048 12.541 9.41602Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)

export default Referal
